import { custromMaterialsGroups } from '@shared/models/consts';
import { MaterialOption } from '@shared/models/material-option';

const defaultMaterialOptions: Record<string, MaterialOption[]> = {
	[custromMaterialsGroups.Ceramic]: [
		{
			ForSpecificationIds: [-1, 1, 2, 3, 4, 5, 6, 7],
			StumpShadeVisible: true,
			StumpShadeMandatory: false,
			ShadeVisible: true,
			BodyShadeMandatory: true,
			MarginDesignVisible: true,
			MarginDesignMandatory: false,
			PrepDesignVisible: true,
			PrepDesignMandatory: false,
			PrepDesignValues: ['Chamfer', 'Shoulder']
		}
	],
	[custromMaterialsGroups.Metal]: [
		{
			ForSpecificationIds: [-1, 1, 3, 4, 5, 6, 7],
			StumpShadeVisible: false,
			StumpShadeMandatory: false,
			ShadeVisible: false,
			BodyShadeMandatory: false,
			MarginDesignVisible: true,
			MarginDesignMandatory: false,
			PrepDesignVisible: true,
			PrepDesignMandatory: false,
			PrepDesignValues: ['Chamfer', 'Shoulder', 'FeatherEdge', 'ShoulderBevel']
		},
		{
			ForSpecificationIds: [2],
			StumpShadeVisible: false,
			StumpShadeMandatory: false,
			ShadeVisible: true,
			BodyShadeMandatory: true,
			MarginDesignVisible: true,
			MarginDesignMandatory: false,
			PrepDesignVisible: true,
			PrepDesignMandatory: false,
			PrepDesignValues: ['Chamfer', 'Shoulder', 'FeatherEdge', 'ShoulderBevel']
		}
	],
	[custromMaterialsGroups.Composites]: [
		{
			ForSpecificationIds: [-1, 1, 2, 3, 4, 5, 6, 7],
			StumpShadeVisible: true,
			StumpShadeMandatory: false,
			ShadeVisible: true,
			BodyShadeMandatory: true,
			MarginDesignVisible: true,
			MarginDesignMandatory: false,
			PrepDesignVisible: true,
			PrepDesignMandatory: false,
			PrepDesignValues: ['Chamfer', 'Shoulder', 'FeatherEdge', 'ShoulderBevel']
		}
	]
};

const defaultMaterialOptionsFallback: MaterialOption[] = [
	{
		ForSpecificationIds: [],
		StumpShadeVisible: false,
		StumpShadeMandatory: false,
		ShadeVisible: false,
		BodyShadeMandatory: false,
		MarginDesignVisible: false,
		MarginDesignMandatory: false,
		PrepDesignVisible: false,
		PrepDesignMandatory: false,
		PrepDesignValues: []
	}
];

export const getDefaultMaterialOptions = (materialGroup: string | undefined): MaterialOption[] => {
	return materialGroup && defaultMaterialOptions[materialGroup] ? defaultMaterialOptions[materialGroup] : defaultMaterialOptionsFallback;
};
